import { useEffect, useState} from "react"
import { useLocation } from "react-router-dom"
import AuthView from './Auth'
import UnAuthView from './UnAuth'
import Navbar from "../components/Navbar";
import SideBar from "../components/SideBar"
import LoadingScreen from "../pages/shared/LoadingScreen"

import { useAuthState } from '../contexts/authcontext'
import { useLoadAuthUser } from "../hooks/authhooks";
import { useLoadCommunityResourcesOnly } from '../hooks/resourcehooks'

import { FilterType, SearchFilterOptionType } from '../data/types';
import { useAppState } from "../contexts/appcontext";

const DashboardRouter = () => {
  const { loadAuthUser, isLoading, isRestoringSession } = useLoadAuthUser()
  var { communityId, isloggedin, isverified, primaryCommunity, authUser } = useAuthState()
  let { isLoadingResources } = useLoadCommunityResourcesOnly(communityId || undefined)
  const location = useLocation()
  const isLeadsRoute = location.pathname.startsWith('/leads')

  const defaultUSState = ''
  const [searchTerm, changeSearchTerm] = useState<string>("");
  const [currentFilter, setCurrentFilter] = useState<FilterType>({state: defaultUSState});
  const [signInModalIsOpen, setSignInModalIsOpen] = useState(false);
  const { isCollapsed } = useAppState()
  // const [loading, setLoading] = useState(true);

  const searchFilterOptions: SearchFilterOptionType = {
    searchTerm,
    currentFilter,
    signInModalIsOpen,
    changeSearchTerm,
    setCurrentFilter,
    setSignInModalIsOpen,
  }

  useEffect(() => {
    loadAuthUser()
     // eslint-disable-next-line
  }, [])

  const isOtpFormView = isloggedin && !isverified
  var isPostOnboardView = isloggedin && isverified
  const isUatView = location.pathname === '/uat'

  if ((isRestoringSession || isLoading || (isLoadingResources && !isLeadsRoute)) && !isUatView){
    return (
      <LoadingScreen />
    )
  } else { 
  return (
    <div className={`flex h-screen min-w-0 ${(isloggedin && !isUatView && !isOtpFormView) ? ((isCollapsed) ? 'ml-[90px]' : 'ml-[250px]') : ''} `}>
  
      {
        (isloggedin && !isUatView) ? (
          <>
          {
            (isOtpFormView) ? <></> : <SideBar />
          }
            <Navbar />
          </>
        ) : (
          <></>
        )
      }
      
      {
        (isPostOnboardView && !isUatView) ? (
          <AuthView
            searchFilterOptions={searchFilterOptions}
            primaryCommunity={primaryCommunity}
            authEmail={authUser?.email ?? authUser?.username}
          />
        ) : (
          <UnAuthView />
        )
      }
    </div>
    )
  }
}


export default DashboardRouter;
